import { useState, type FormEvent } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthLayout } from "../app/layouts/AuthLayout";
import { Button } from "../components/ui/Button";
import { Input } from "../components/ui/Input";
import { apiClient, ApiError } from "../lib/api-client";
import { useAuth } from "../features/auth/AuthProvider";

export default function AcceptInvitePage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await apiClient.post("/api/auth/accept-invite", {
        json: { token, name, password },
      });
      await refresh();
      navigate("/leads", { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 400) {
        setError("Invite is invalid or has expired.");
      } else {
        setError("Could not accept the invite. Try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return <AuthLayout title="Accept invite" subtitle="No token provided.">{null}</AuthLayout>;
  }

  return (
    <AuthLayout title="Join the workspace" subtitle="Set your name and a password to finish onboarding.">
      <form onSubmit={onSubmit} className="form-stack">
        <Input label="Your name" value={name} onChange={(e) => setName(e.target.value)} required />
        <Input
          label="Password"
          type="password"
          minLength={8}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error ? <div className="form-error">{error}</div> : null}
        <Button type="submit" disabled={submitting}>
          {submitting ? "Creating account…" : "Create account"}
        </Button>
      </form>
    </AuthLayout>
  );
}
